<template>
  <div class="handler">
    <el-form :model="formData" class="searchBar">
      <div class="select_from_store_name" v-if="storeNameRender()">
        <label-input
          label="门店名称"
          placeholder="请输入门店名称"
          :disabled="disRen()"
          v-model="formData.storeName"
          width="334px"
          type="autocomplete"
          :_parent="_self"
        ></label-input>
      </div>
      <el-form-item class="fl" v-if="storeStatusRender() && $store.getters.isChain == '1'">
        <el-select v-model="formData.areaId" placeholder="所属大区">
          <el-option v-for="(t, k) in areaList" :key="k" :label="t.name" :value="t.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="fl" v-if="storeStatusRender()">
        <el-select v-model="formData.status" :disabled="disRen()" placeholder="门店状态">
          <el-option v-for="(t, k) in storeStatus" :key="k" :label="t" :value="k"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="fl" v-if="storeStatusRender() && !!$store.getters.isChain">
        <el-select v-model="formData.type" placeholder="服务类型">
          <el-option v-for="(value, key) in serviceType" :key="key" :label="value" :value="key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="fl remotePharmacistStatus" v-if="storeStatusRender()">
        <el-select :disabled="disRen()" v-model="formData.remotePharmacistStatus" placeholder="远程药师审方状态">
          <el-option v-for="(t, k) in remotePharmacistStatus" :key="k" :label="t" :value="k"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="fl storePharmacistStatus" v-if="storeStatusRender()">
        <el-select :disabled="disRen()" v-model="formData.storePharmacistStatus" placeholder="驻店药师审方状态">
          <el-option v-for="(t, k) in storePharmacistStatus" :key="k" :label="t" :value="k"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="fl faceStatus" v-if="storeStatusRender()">
        <el-select :disabled="disRen()" v-model="formData.faceStatus" placeholder="人脸识别状态">
          <el-option v-for="(t, k) in faceStatus" :key="k" :label="t" :value="k"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="fl" v-if="showStatusRender()">
        <el-button type="info" plain @click="onSubmit" class="search-btn" :disabled="disRen()">查询</el-button>
      </el-form-item>
      <!--      <el-form-item class="fl " v-if="showExportFun()">-->
      <!--        <el-button type="info" plain @click="onExportData" class="search-btn" :disabled="disRen()">导出</el-button>-->
      <!--      </el-form-item>-->
    </el-form>
  </div>
</template>
<script>
import labelInput from '@/components/global/form/labelInput';
import { hasPermission, downloadByLink, transformParamToUrl, downloadByIframe } from '@/util/index';
import Constant from '@/lib/constant';
import Fetch from '@/api';

const baseRole = Constant.RoleList;
export default {
  name: 'breadTab',
  components: { labelInput },
  computed: {
    mode() {
      return this.$store.getters.getShopManagementMode;
    }
  },
  data() {
    return {
      formData: {
        status: null, //
        storeName: '', //
        // storeStatus: null, // 店铺状态
        remotePharmacistStatus: null, // 远程审方药师筛选开关
        storePharmacistStatus: null, // 驻店药师审方筛选开关
        faceStatus: null, // 人脸识别审方筛选开关
        areaId: null,
        type: null // 药店服务类型
      },
      searchStatus: Constant.searchStatus,
      remotePharmacistStatus: Constant.openStatus,
      storeStatus: Constant.storeStatus, // 门店状态
      storePharmacistStatus: Constant.openStatus,
      faceStatus: Constant.openStatus,
      serviceType: Constant.serviceType,
      areaList: [{ id: '', name: '全部' }]
    };
  },
  created() {
    this.$checkPower('a,c') && this.getAreaList();
  },
  watch: {
    searchData: {
      handler: function (val) {
        this.formData = val;
      },
      deep: true
    }
  },
  methods: {
    showExportFun() {
      let per = [baseRole.a, baseRole.c, baseRole.d];
      return hasPermission(per);
    },
    showStatusRender() {
      // 查询按钮展示逻辑
      let per = [baseRole.a, baseRole.c, baseRole.h];
      return hasPermission(per);
    },
    storeStatusRender() {
      // 渲染门店状态筛选
      let per = [baseRole.a, baseRole.c];
      return hasPermission(per);
    },
    storeNameRender() {
      // 渲染药店筛选逻辑
      let per = [baseRole.a, baseRole.c, baseRole.h];
      return hasPermission(per);
    },
    disRen() {
      if (this.mode == 1) {
        // 正常模式
        return false;
      } else if (this.mode == 2) {
        // 编辑模式
        return true;
      }
    },
    onSubmit() {
      // 点击查询时 获取数据
      // this.formData.storeName = this.$refs.store_name.getValue();
      this.$emit('search', this.formData);
    },

    addStore() {
      this.$router.push('/shopManagement/addShop');
    },
    getAreaList() {
      return Fetch.queryAreaList({ companyId: this.$store.getters.companyId, pageNo: 1, pageSize: 1000 }).then(
        ({ data }) => {
          this.areaList = data && this.areaList.concat(data);
        }
      );
    },
    onExportData() {
      this.onSubmit();
      // 导出店铺数据
      let { faceStatus, remotePharmacistStatus, status, storeName, storePharmacistStatus } = this.formData;

      const baseUrl = `${Util.getGwRoot}drugstore/1.0/export_store`;

      const data = {
        faceStatus: faceStatus || null,
        remotePharmacistStatus: remotePharmacistStatus || null,
        status: status || null,
        storeName: storeName || null,
        storePharmacistStatus: storePharmacistStatus || null
      };
      const str = transformParamToUrl(data);

      const openUrl = `${baseUrl}?${str}&isDelete=0`;
      downloadByIframe(openUrl, '门店数据');
    },
    setFormStoreId(val) {
      this.formData.storeId = val;
    }
  }
};
</script>
<style lang="scss" scoped>
.tab-pre,
.el-breadcrumb {
  font-size: 12px;
  color: #999999;
  line-height: 40px;
}
.add-btn {
  float: left;
  margin-right: 16px;
  border: 1px solid #ebb436;
  text-align: center;
  width: 178px;
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
  cursor: pointer;
  span {
    color: #ebb436;
    font-weight: 500;
  }
}
.select_from_store_name {
  float: left;
  margin-right: 16px;
}
.select_from_user_name {
  float: left;
  margin-right: 16px;
}
.el-select {
  width: 176px;
}
.fl {
  float: left;
  margin-right: 16px;
  margin-bottom: 16px;
  height: 40px;
}
.fr {
  float: right;
  margin-right: 16px;
}
.last {
  margin-right: 0;
}
.link {
  width: 176px;
  background: #fff !important;
  color: #bdbdbd !important;
  text-align: left;
  padding: 12px 12px;
  span {
    i {
      float: right;
    }
  }
  &:hover {
    color: #bdbdbd !important;
  }
}
.search-btn {
  background: #fff !important;
  color: #1e8dff !important;
  height: 40px !important;
  width: 80px !important;
  border: 1px solid #1e8dff !important;
  &:hover {
    background: rgba(68, 184, 91, 0.1) !important;
  }
}
.is-disabled {
  border-color: #e4e7ed !important;
  background-color: #f5f7fa !important;
  color: #c0c4cc !important;
}

// @media screen and (max-width: 1000px) {
// }
// @media screen and (max-width: 1532px) {
//   .search-btn {
//     margin-top: 16px;
//   }
// }
// @media screen and (max-width: 1532px) {
//   .search-btn {
//     margin-top: 16px;
//   }
//   .remotePharmacistStatus {
//     margin-top: 16px;
//   }
//   .storePharmacistStatus {
//     margin-top: 16px;
//   }
//   .faceStatus {
//     margin-top: 16px;
//   }
// }
// @media screen and (min-width: 1052px) {
//   .remotePharmacistStatus {
//     margin-top: 0px;
//   }
// }
// @media screen and (min-width: 1245px) {
//   .storePharmacistStatus {
//     margin-top: 0px;
//   }
// }
// @media screen and (min-width: 1450px) {
//   .faceStatus {
//     margin-top: 0px;
//   }
// }
</style>
